import type { Card } from '../types/card';
import type { DecidedPriceResult } from '../types/decidedPrice';

/**
 * 판매가 결정 API(PUT /{id}/decided-price) 저장 결과를 카드 캐시에 덮을 값 — 서버 markDecided 와 같은 칸(판매가 결정 화면
 * DecidedPricePage 의 onCardsPatched 와 같은 규칙, 감사 card-controltower#538 · #558): 수정가 = 결정가 · 수동 · 감지/분류 비움,
 * 네이버 반영 성공이면 기준가(네이버 가격)도 결정가로 · 변동 없음. 사람이 정한 가격 보호(priceHeld)는 결정이 대신하므로 끈다.
 */
export function decidedCardPatch(card: Card, price: number, naverSuccess: boolean): Card {
  return {
    ...card,
    suggestedPrice: price,
    currentPrice: naverSuccess ? price : card.currentPrice,
    isManual: true,
    manualOverrideAt: null,
    priceHeld: false,
    dropBucket: null, dropSeverity: null, dropReason: null,
    marketMin: null, marketMax: null, marketShopCount: null, marketCheckedAt: null,
    ...(naverSuccess ? { priceChangeStatus: 'UNCHANGED' as const, priceChangeRate: 0 } : {}),
  };
}

/**
 * 저장 결과 안내 한 줄 — 성공이면 '네이버 반영 · PriceHub 보고', 네이버 실패 · 결과 불명 · PriceHub 보고 안 됨은 사유와 함께.
 * level 은 토스트 종류.
 */
export function decidedSaveNotice(r: DecidedPriceResult, label: string): { level: 'success' | 'warning'; text: string } {
  const won = `${r.price.toLocaleString('ko-KR')}원`;
  const hubNote = r.hub && !r.hub.reported ? ` · PriceHub 보고 안 됨${r.hub.message ? `(${r.hub.message})` : ''}` : '';
  if (r.naver.status === 'SUCCESS') {
    return { level: hubNote ? 'warning' : 'success', text: `${label} ${won} — 네이버 반영${hubNote || ' · PriceHub 보고'}` };
  }
  if (r.naver.status === 'UNKNOWN') {
    return { level: 'warning', text: `${label} ${won} 저장 — 네이버 반영 결과 불명${r.naver.message ? `(${r.naver.message})` : ''}, 반영 로그에서 확인하세요${hubNote}` };
  }
  return { level: 'warning', text: `${label} ${won} 저장 — 네이버 반영 실패${r.naver.message ? `(${r.naver.message})` : ''}, ③ 스토어 반영에서 다시 보냅니다${hubNote}` };
}
